import * as React from 'react';
import type { MenuProps } from 'antd';
import Logo from '../assets/reeach-maker_logo.svg?react';
import LangMenu from './LangMenu';
import { useTranslation } from 'react-i18next';
import HelpBoxCompanion from './HelpBoxCompanion';
import { observer } from 'mobx-react-lite';
import StepperModel from '../models/StepperModel';
import { STEP_SITE_BUILDER } from '../steps/steps-definitions';
import SiteBuilderModel from '../steps/SiteBuilder/model/SiteBuilderModel';

type MenuItem = Required<MenuProps>['items'][number];

interface FCProps { }

const Header: React.FC<FCProps> = observer(({ }) => {
  const { t } = useTranslation();
  const [current, setCurrent] = React.useState('mail');
  
  const isPreviewMode = StepperModel.currentStep === STEP_SITE_BUILDER && SiteBuilderModel.iframeVisibility;

  return (
    <header  style={{ borderTop: '1px solid rgb(255, 255, 255)', backgroundColor: 'rgb(255, 255, 255, 0.2)' }}>
      <div 
        className={`px-5 md:px-10 ${
          isPreviewMode ? 'py-4 md:py-[68px] md:pt-[63px] fixed bottom-0 left-0 right-0 bg-white' : 'py-[68px] md:pt-[63px]'
        }`}
        style={isPreviewMode ? { zIndex: 999 } : {}}
      >
        <div
          className={
            isPreviewMode
              ? 'flex flex-row items-center justify-between gap-2 w-full'
              : 'flex flex-col sm:flex-row items-center sm:items-start justify-between h-full gap-8 sm:gap-0'
          }>
          <div
            className={
              isPreviewMode
                ? 'shrink-0 min-w-0 flex items-center opacity-75'
                : 'w-full md:w-auto flex justify-center sm:justify-start opacity-75'
            }>
            <Logo className={isPreviewMode ? 'w-auto sm:h-[40px]' : undefined} />
          </div>
          <div
            className={
              isPreviewMode
                ? 'shrink-0 flex items-center justify-end'
                : 'w-full sm:w-auto flex justify-center sm:justify-end'
            }>
            <LangMenu />
          </div>
          <HelpBoxCompanion children="this is some help text" />
        </div>
      </div>

    </header>
  );
});

export default Header;